import { createSlice } from "@reduxjs/toolkit";

const portalUserSlice = createSlice({
    name: 'portal_user',
    initialState: {
        data: [],
        totalRows: 0,
        currentPage: 0, 
        rowsPerPage: 5,
        searchTerm: '',
        filters: {
            status: '',
        },
        action: {
            isLoading: false,
            isError: false,
            errorMessage: ''
        },
        isLoading: false,
        isError: false,
        errorMessage: '',
    }, 
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        setTotalRows: (state, action) => {
            state.totalRows = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.filters.status = action.payload;
        },
        fetchingData: (state) => {
            state.isLoading = true;
            state.isError = false;
        },
        fetchDataSuccess: (state, action) => {
            action.payload?.data && (state.data = action.payload.data);
            action.payload?.total_items && (state.totalRows = action.payload.total_items);

            state.isLoading = false;
            state.isError = false;
        },
        fetchDataFail: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errorMessage = action.payload;
        },
        submittingData: (state) => {
            state.action.isLoading = true;
            state.action.isError = false;
        },
        submitDataSuccess: (state) => {
            state.action.isLoading = false;
            state.action.isError = false;
        },
        submitDataFail: (state) => {
            state.action.isLoading = false;
            state.action.isError = true;
            state.action.errorMessage = '';
        },
        reloadDialogState: (state) => {
            state.action = { isLoading: false, isError: false, errorMessage: ''}
        }
    }
});

export const {
    setData,
    setTotalRows,
    setCurrentPage,
    setRowsPerPage,
    setSearchTerm,
    setStatusFilter,
    
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,
    submittingData,
    submitDataSuccess,
    submitDataFail,
    reloadDialogState
} = portalUserSlice.actions;

export default portalUserSlice.reducer;